export enum ProvinceEnum {
  'Empty',
  'Gauteng',
  'Limpopo',
  'North West',
  'Western Cape',
  'Eastern Cape',
  'Northern Cape',
  'Free State',
  'Mpumalanga',
  'Kwazulu Natal',
  'Namibia',
  'Lesotho',
  'SwaziLand'
}

export namespace ProvinceEnum {
  export function values() {
    return Object.keys(ProvinceEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
